module.exports = __webpack_public_path__ + "img/icon-sparkle.5bfedb6f.svg";